export const siteSettings = {
  name: "Luno Tradex",
  link: "https://lunotradex.com",
  email: "support@lunotradex.com",
  appLink: "https://app.lunotradex.com",
};
